import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import loginServices from '../../Service/login.service'
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home'
    },
    {
        id: 2,
        title: 'About',
        link: '/about',
    },
    {
        id: 3,
        title: 'Services',
        link: '/services',
    },
    {
        id: 4,
        title: 'Shop',
        link: '/shop'
    },
    {
        id: 5,
        title: 'Contact',
        link: '/contact',
    }
];

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {/* <NavLink className="active" to={item.link}>{item.title}</NavLink> */}
                            </ListItem>
                        )
                    })}
                    <ListItem>
                        <NavLink className="active" to="/orders/new">Order Now</NavLink>
                    </ListItem>
                    <ListItem>
                        {localStorage.getItem("user") ? (
                            <NavLink className="active" to="/" onClick={() => {
                                loginServices.logOut();
                                window.location.href = '/login';
                            }}>Logout</NavLink>
                        ) : (
                            <NavLink className="active" to="/login">Login</NavLink>
                        )}
                    </ListItem>
                </ul>
            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;